import { render, staticRenderFns } from "./ProjectSlider.vue?vue&type=template&id=2354a676&scoped=true&"
import script from "./ProjectSlider.vue?vue&type=script&lang=js&"
export * from "./ProjectSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSlider.vue?vue&type=style&index=0&id=2354a676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354a676",
  null
  
)

export default component.exports